// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"23":"registro","312":"blank","368":"confirm","756":"thanks"}[chunkId] + "." + {"23":"8ee3ed5f","312":"d51b8478","368":"ef5a0c31","756":"d51b8478"}[chunkId] + ".css";
};